const React = require('react');

const Content = require('./Content.jsx');
const _Image = require('./Image.jsx');
const TypeConfig = require('./TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

function StringMeta(props) {
    if (!Utilities.Config.checkVisibility(props, props.name)) {
        return null;
    }
    const itemData = props.itemData || {};
    const propName = props.propName || props.name;
    let content = itemData[propName];
    if (content != undefined) {
        content = content.toString();
    }
    return <Content.Value {...props} value={content} />;
}

function AlternateDimensions(props) {
    return <StringMeta {...props} name="AlternateDimensions" />;
}
const TypeConfigAlternateDimensions = {
    panel: {
        block: function () { return Content.TypeConfig.value.panel.block(); },
        style: Content.TypeConfig.value.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Alternate Dimensions',
                        name: 'AlternateDimensions',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function Artist(props) {
    const itemData = props.itemData || {};
    let content;
    if (itemData.Artist) {
        content = itemData.Artist.Name;
    }
    return <Content.Value {...props} value={content} />;
}
const TypeConfigArtist = {
    panel: {
        block: function () { return Content.TypeConfig.value.panel.block({}); },
        style: Content.TypeConfig.value.panel.style
    }
};

class CustomMeta extends React.Component {
    constructor(props) {
        super(props);

        this.handleTypeValue = this.handleTypeValue.bind(this);
    }

    handleTypeValue(id, itemData) {
        let replaceString = `[${id}]`;
        let value;
        if (this.props.onTypeValue) {
            const temp = this.props.onTypeValue(id, itemData);
            if (temp) {
                replaceString = temp.replaceString || replaceString;
                value = temp.value;
            }
        }
        let metaProps = {};
        if (this.props.config && this.props.config.Config && this.props.config.Config.Meta) {
            metaProps = this.props.config.Config.Meta;
        }
        let formatString = metaProps[`format${id}`];
        if (!value) {
            switch (id) {
                case 'Artist':
                    if (itemData.Artist) {
                        value = itemData.Artist.Name;
                    }
                    break;
                case 'Edition':
                    if (itemData.Type == 0) {
                        let number = '';
                        if (itemData.EditionNumber) {
                            number = itemData.EditionNumber;
                        }
                        switch (itemData.EditionType) {
                            case 1:
                                let count = '';
                                if (itemData.EditionCount) {
                                    count = itemData.EditionCount;
                                }
                                formatString = metaProps.formatEditionLimited;
                                if (formatString) {
                                    return formatString.replace('[EditionNumber]', number).replace('[EditionCount]', count);
                                }
                                break;
                            case 2:
                                formatString = metaProps.formatEditionUnlimited;
                                if (formatString) {
                                    return formatString.replace('[EditionNumber]', number);
                                }
                                break;
                        }
                    }
                    break;
                case 'Framed':
                    replaceString = '[Framing]';
                    value = itemData.Framed;
                    break;
                case 'Price':
                    if (!Utilities.isNullOrWhitespace(itemData.Price)) {
                        let currencyFormat = metaProps.currencyFormatPrice;
                        if (this.props.customFirstLineFormat == true) {
                            const componentData = this.props.componentData || {};
                            if (componentData.index == 0) {
                                currencyFormat = metaProps.currencyFormatPriceFirst;
                            }
                        }
                        const data = this.props.data || {};
                        let localization = {};
                        if (data.Gallery && data.Gallery.Localization) {
                            localization = data.Gallery.Localization;
                        }
                        return Utilities.Format.Currency.getDisplayString(itemData.Price, currencyFormat, localization)
                    }
                    break;
                case 'PriceOverride':
                    replaceString = '[DisplayPrice]';
                    value = itemData.PriceOverride;
                    break;
                default:
                    value = itemData[`${id}`];
                    break;
            }
        }
        if (Utilities.isNullOrWhitespace(value)) {
            return;
        }
        if (formatString) {
            value = formatString.replace(replaceString, value);
        }
        return value;
    }

    render() {
        const props = this.props;
        const config = props.config || {};
        let metaProps = {}
        let includes = {}
        if (config.Config) {
            if (config.Config.Meta) {
                metaProps = config.Config.Meta;
            }
            if (config.Config.Includes) {
                includes = config.Config.Includes;
            }
        }
        const data = props.data || {};
        const itemData = props.itemData || {};
        let displayItems = [];
        let delimiter, displayItem, id, value;
        for (let i = 0; i < includes._sort.length; i++) {
            id = includes._sort[i];

            if (!includes[id]) {
                continue;
            }
            value = this.handleTypeValue(id, itemData);
            if (Utilities.isNullOrWhitespace(value)) {
                continue;
            }
            displayItem = {
                style: Utilities.Config.getStyle(data, metaProps, id, { display: 'inline-block' }),
                value: value
            };
            delimiter = metaProps[`delimiter${id}`];
            if (delimiter) {
                displayItem.delimiter = delimiter;
                delimiter = undefined;
            }
            displayItems.push(displayItem);
            value = undefined;
        }
        const displayItemCount = displayItems.length;
        displayItems = displayItems.map(function (d, index) {
            let value = d.value;
            if (d.delimiter && index < displayItemCount - 1) {
                value += d.delimiter;
            }
            return <span key={index} style={d.style}>{value}</span>;
        });
        if (!props.builder && !displayItems.length) {
            return null;
        }
        const Component = props.component || Content.Value;
        return <Component {...props} style={{ whiteSpace: 'pre-wrap' }} value={displayItems} />;
    }
}
const TypeConfigCustomMeta = {
    options: {
        meta: function (props, textTransform, shouldPad) {
            const _props = props || {};
            const _name = _props.propName || _props.name || '';
            const visible = function (config) { return config.Includes && config.Includes[_name]; };

            let options = [];
            let spacerCount = 0;
            switch (_props.type) {
                case 'currency':
                    options.push(TypeConfig.options.currency({ includeHelpText: _props.includeHelpText, name: _name, visible: visible }));
                    spacerCount = 1;
                    break;
                case 'edition':
                    spacerCount = 1;
                    break;
                default:
                    options.push({
                        display: 'Display Format',
                        helpText: () => `Keywords: ${_props.keywords || _props.value}`,
                        name: `format${_name}`,
                        type: 'format',
                        value: `${props.value}`,
                        visible: visible
                    });
                    break;
            }
            options.push({
                display: 'Delimiter',
                name: `delimiter${_name}`,
                type: 'text',
                value: ', ',
                visible: visible
            });
            for (let i = 0; i < spacerCount; i++) {
                options.push({ type: 'spacer', visible: visible });
            }
            options = options.concat(TypeConfig.options.text({ visible: visible, ..._props }, {}, textTransform));
            if (shouldPad != false) {
                const count = textTransform != undefined ? 3 : 2;
                for (let i = 0; i < count; i++) {
                    options.push({ type: 'spacer', visible: visible });
                }
            }
            return options;
        }
    },
    panel: {
        style: Content.TypeConfig.value.panel.style
    }
};

function Dimensions(props) {
    return <StringMeta {...props} name="Dimensions" />;
}
const TypeConfigDimensions = {
    panel: {
        block: function () { return Content.TypeConfig.value.panel.block(); },
        style: Content.TypeConfig.value.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Dimensions',
                        name: 'Dimensions',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function DisplayPrice(props) {
    return <StringMeta {...props} name="DisplayPrice" propName="PriceOverride" />;
}
const TypeConfigDisplayPrice = {
    panel: {
        block: function () { return Content.TypeConfig.value.panel.block({}); },
        style: Content.TypeConfig.value.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Price Override',
                        name: 'DisplayPrice',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function Edition(props) {
    if (!Utilities.Config.checkVisibility(props, 'Edition')) {
        return null;
    }
    const config = props.config || {};
    let blockProps = {}
    let formatProps = {}
    if (config.Config) {
        if (config.Config.Block) {
            blockProps = config.Config.Block;
        }
        if (config.Config.Format) {
            formatProps = config.Config.Format;
        }
    }
    const itemData = props.itemData || {};
    const content = Utilities.Inventory.getEditionNumberWithFormat(itemData, formatProps.formatLimited, formatProps.formatUnlimited);
    return <Content.Value {...props} style={{ whiteSpace: 'pre-wrap' }} value={content} />;
}
const TypeConfigEdition = {
    panel: {
        block: function () { return Content.TypeConfig.value.panel.block(); },
        format: function () {
            return {
                expanded: false,
                label: 'Advanced',
                options: [
                    {
                        display: 'Limited Edition Display Format',
                        fullWidth: true,
                        helpText: () => 'Keywords: [EditionNumber], [EditionCount]',
                        name: 'formatLimited',
                        type: 'format',
                        value: 'Edition [EditionNumber]/[EditionCount]'
                    },
                    {
                        display: 'Unlimited Edition Display Format',
                        fullWidth: true,
                        helpText: () => 'Keywords: [EditionNumber]',
                        name: 'formatUnlimited',
                        type: 'format',
                        value: 'Edition [EditionNumber]'
                    }
                ]
            };
        },
        style: Content.TypeConfig.value.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Edition Info',
                        name: 'Edition',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function Framed(props) {
    return <StringMeta {...props} name="Framed" />;
}
const TypeConfigFramed = {
    panel: {
        block: function () { return Content.TypeConfig.value.panel.block(); },
        style: Content.TypeConfig.value.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Framing',
                        name: 'Framed',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function Image(props) {
    const itemData = props.itemData || {};
    return <_Image.Component {...props} alt={itemData.Title} imageUrl={itemData.ImageUrl} url={itemData.Url} />
}

function Location(props) {
    return <StringMeta {...props} name="Location" />;
}
const TypeConfigLocation = {
    panel: {
        block: function () { return Content.TypeConfig.value.panel.block({}); },
        style: Content.TypeConfig.value.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Location',
                        name: 'Location',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function Medium(props) {
    return <StringMeta {...props} name="Medium" />;
}
const TypeConfigMedium = {
    panel: {
        block: function () { return Content.TypeConfig.value.panel.block({}); },
        style: Content.TypeConfig.value.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Medium',
                        name: 'Medium',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function Number(props) {
    if (!Utilities.Config.checkVisibility(props, 'Number')) {
        return null;
    }
    const config = props.config || {};
    let blockProps = {}
    if (config.Config && config.Config.Block) {
        blockProps = config.Config.Block;
    }
    const itemData = props.itemData || {};
    let content;
    if (!Utilities.isNullOrWhitespace(itemData.Number)) {
        content = `${blockProps.textLabel}${itemData.Number}`;
    }
    return <Content.Value {...props} style={{ whiteSpace: 'pre-wrap' }} value={content} />;
}
const TypeConfigNumber = {
    panel: {
        block: function () { return Content.TypeConfig.value.panel.blockWithLabel({ value: 'Inventory #: ' }); },
        style: Content.TypeConfig.value.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Inventory Number',
                        name: 'Number',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function Price(props) {
    if (!Utilities.Config.checkVisibility(props, 'Price')) {
        return null;
    }
    const config = props.config || {};
    let formatProps = {}
    if (config.Config && config.Config.Format) {
        formatProps = config.Config.Format;
    }
    let currencyFormat = formatProps.currencyFormat;
    if (props.customFirstLineFormat == true) {
        const componentData = props.componentData || {};
        if (componentData.index == 0) {
            currencyFormat = formatProps.currencyFormatFirst;
        }
    }
    const itemData = props.itemData || {};
    let localization;
    if (props.data && props.data.Gallery) {
        localization = props.data.Gallery.Localization;
    }
    const propName = props.propName || 'Price';
    const content = Utilities.Format.Currency.getDisplayString(itemData[propName], currencyFormat, localization);
    return <Content.Value {...props} style={{ whiteSpace: 'pre-wrap' }} value={content} />;
}
const TypeConfigPrice = {
    panel: {
        block: function () { return Content.TypeConfig.value.panel.block(); },
        format: function () { return TypeConfig.panel.currency(); },
        style: Content.TypeConfig.value.panel.style,
        visibility: function (props) {
            const _props = props || {};
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Retail Price',
                        name: 'Price',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; },
                        ..._props
                    }
                ]
            }
        }
    }
};

function Signature(props) {
    if (!Utilities.Config.checkVisibility(props, 'Signature')) {
        return null;
    }
    const config = props.config || {};
    let blockProps = {}
    if (config.Config && config.Config.Block) {
        blockProps = config.Config.Block;
    }
    const itemData = props.itemData || {};
    let content;
    if (!Utilities.isNullOrWhitespace(itemData.Signature)) {
        content = `${blockProps.textLabel}${itemData.Signature}`;
    }
    return <Content.Value {...props} style={{ whiteSpace: 'pre-wrap' }} value={content} />;
}
const TypeConfigSignature = {
    panel: {
        block: function () { return Content.TypeConfig.value.panel.blockWithLabel({ value: 'Signature: ' }); },
        style: Content.TypeConfig.value.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Inventory Signature',
                        name: 'Signature',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function SKU(props) {
    if (!Utilities.Config.checkVisibility(props, 'SKU')) {
        return null;
    }
    const config = props.config || {};
    let blockProps = {}
    if (config.Config && config.Config.Block) {
        blockProps = config.Config.Block;
    }
    const itemData = props.itemData || {};
    let content;
    if (!Utilities.isNullOrWhitespace(itemData.SKU)) {
        content = `${blockProps.textLabel}${itemData.SKU}`;
    }
    return <Content.Value {...props} style={{ whiteSpace: 'pre-wrap' }} value={content} />;
}
const TypeConfigSKU = {
    panel: {
        block: function () { return Content.TypeConfig.value.panel.blockWithLabel({ value: 'SKU: ' }); },
        style: Content.TypeConfig.value.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'SKU',
                        name: 'SKU',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function Title(props) {
    let includes = {}
    if (props.config && props.config.Config && props.config.Config.Includes) {
        includes = props.config.Config.Includes;
    }
    const itemData = props.itemData || {};
    const content = [];
    if (!Utilities.isNullOrWhitespace(itemData.Title)) {
        content.push(<React.Fragment key="title">{itemData.Title}</React.Fragment>);
    }
    let subtitle = Utilities.Inventory.getSubtitle(itemData, includes.Edition, includes.Date);
    if (subtitle && subtitle.length > 0) {
        content.push(<span key="subtitle" style={{ fontStyle: 'initial' }}>{subtitle}</span>);
    }
    return <Content.Value {...props} style={{ fontStyle: 'italic' }} value={content} />;
}
const TypeConfigTitle = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: TypeConfig.options.text({}, undefined, {})
            };
        },
        includes: function (date) {
            const options = [
                { display: 'Edition Info', name: 'Edition', type: 'checkbox', value: true, configurableDuringExport: function () { return true; } }
            ];
            if (date) {
                options.push({ display: 'Date', name: 'Date', type: 'checkbox', value: true, configurableDuringExport: function () { return true; }, ...date })
            }
            return {
                expanded: false,
                label: 'Include',
                options: options
            };
        },
        style: Content.TypeConfig.value.panel.style
    }
};

module.exports = {
    AlternateDimensions: {
        Component: AlternateDimensions,
        TypeConfig: TypeConfigAlternateDimensions
    },
    Artist: {
        Component: Artist,
        TypeConfig: TypeConfigArtist
    },
    CustomMeta: {
        Component: CustomMeta,
        TypeConfig: TypeConfigCustomMeta
    },
    Dimensions: {
        Component: Dimensions,
        TypeConfig: TypeConfigDimensions
    },
    DisplayPrice: {
        Component: DisplayPrice,
        TypeConfig: TypeConfigDisplayPrice
    },
    Edition: {
        Component: Edition,
        TypeConfig: TypeConfigEdition
    },
    Framed: {
        Component: Framed,
        TypeConfig: TypeConfigFramed
    },
    Image: {
        Component: Image,
        TypeConfig: _Image.TypeConfig
    },
    Location: {
        Component: Location,
        TypeConfig: TypeConfigLocation
    },
    Medium: {
        Component: Medium,
        TypeConfig: TypeConfigMedium
    },
    Meta: Content.Value,
    Number: {
        Component: Number,
        TypeConfig: TypeConfigNumber
    },
    Price: {
        Component: Price,
        TypeConfig: TypeConfigPrice
    },
    Signature: {
        Component: Signature,
        TypeConfig: TypeConfigSignature
    },
    SKU: {
        Component: SKU,
        TypeConfig: TypeConfigSKU
    },
    StringMeta: {
        Component: StringMeta,
        TypeConfig: Content.TypeConfig.value
    },
    Title: {
        Component: Title,
        TypeConfig: TypeConfigTitle
    }
};